export enum Capability {
  /* * * * * * * * * *  * * * * * * * * */
  /* * * * * * *   COCKPIT  * * * * * * */
  /* * * * * * * * * *  * * * * * * * * */
  SWITCH_TARGET_USER = "SWITCH_TARGET_USER",
  SHOW_MY_MESSAGES_TILE = "SHOW_MY_MESSAGES_TILE",                                // Tile 01
  SHOW_PROJECT_ORGRANISATION_TILE = "SHOW_PROJECT_ORGRANISATION_TILE",            // Tile 02
  SHOW_APPOINTMENT_MANAGEMENTILE_TILE = "SHOW_APPOINTMENT_MANAGEMENTILE_TILE",    // Tile 03
  SHOW_RELEVANT_PROJECTS_TILE = "SHOW_RELEVANT_PROJECTS_TILE",                    // Tile 04
  SHOW_MY_APPOINTMENTS_TILE = "SHOW_MY_APPOINTMENTS_TILE",                        // Tile 05
  SHOW_MY_PROJECTS_TILE = "SHOW_MY_PROJECTS_TILE",                                // Tile 06
  SHOW_MY_HY_DRY_DEVICES_TILE = "SHOW_MY_HY_DRY_DEVICES_TILE",                    // Tile 07
  SHOW_ALL_PROJECTS_TILE = "SHOW_ALL_PROJECTS_TILE",                              // Tile 09
  SHOW_ALL_DEVICES_TILE = "SHOW_ALL_DEVICES_TILE",                                // Tile 11                   
  /* * * * * * * * * *  * * * * * * * * */

  /* * * * * * * * * *  * * * * * * * * */
  /* * * * * * *  PROJECTS  * * * * * * */
  /* * * * * * * * * *  * * * * * * * * */
  SEE_ALL_PROJECTS = "SEE_ALL_PROJECTS",
  CREATE_PROJECT = "CREATE_PROJECT",
  REOPEN_COMPLETED_PHASES = "REOPEN_COMPLETED_PHASES",
  EDIT_PROJECT = "EDIT_PROJECT",
  CREATE_APPOINTMENT = "CREATE_APPOINTMENT",
  DELETE_PROJECT = "DELETE_PROJECT",
  LEAK_DETECTION_PROJECTS = "LEAK_DETECTION_PROJECTS",
  DRYING_PROJECTS = "DRYING_PROJECTS",
  OFFICE_PROJECTS = "OFFICE_PROJECTS",
  PROJECT_MANAGEMENT = "PROJECT_MANAGEMENT",
  PROJECT_SUPERVISION = "PROJECT_SUPERVISION",
  DAMAGE_ASSESSMENT_AND_LEAK_DETECTION_PROJECTS = "DAMAGE_ASSESSMENT_AND_LEAK_DETECTION_PROJECTS",
  DRYING_AND_REPAIR_PROJECTS = "DRYING_AND_REPAIR_PROJECTS",
  MANAGER_PROJECTS = "MANAGER_PROJECTS",
  VIEW_ARCHIVED_PROJECTS = "VIEW_ARCHIVED_PROJECTS",
  RESTORE_PROJECT = "RESTORE_PROJECT",
  /** Controls access to move a project to finished state and to reopen a finished project. IRES-exclusive capability. */
  MOVE_PROJECT = "MOVE_PROJECT_TO_FINISHED",
  DEFINE_PROJECT_TYPES = "DEFINE_PROJECT_TYPES",

  SPECIAL_RIGHTS_FOR_PROJECT_TYPE_SELECTION = "SPECIAL_RIGHTS_FOR_PROJECT_TYPE_SELECTION",
  ALWAYS_ALLOWED_TO_CONCLUDE_PROJECT = "ALWAYS_ALLOWED_TO_CONCLUDE_PROJECT",
  ALWAYS_ALLOWED_TO_EDIT_PROJECT = "ALWAYS_ALLOWED_TO_EDIT_PROJECT",
  ALWAYS_ALLOWED_TO_VIEW_TIME_TRACKING = "ALWAYS_ALLOWED_TO_VIEW_TIME_TRACKING",
  ALWAYS_ALLOWED_TO_EDIT_DEVICE_ASSIGNMENTS = "ALWAYS_ALLOWED_TO_EDIT_DEVICE_ASSIGNMENTS",
  ALWAYS_ALLOWED_TO_CORRECT_METER_READINGS = "ALWAYS_ALLOWED_TO_CORRECT_METER_READINGS",
  ALWAYS_ALLOWED_TO_ASSIGN_DEVICES = "ALWAYS_ALLOWED_TO_ASSIGN_DEVICES",
  SKIP_ASSIGNMENT_DATA_VALIDATION = "SKIP_ASSIGNMENT_DATA_VALIDATION",
  ALLOWED_TO_SEE_PROJECT_APP_VERSION = "ALLOWED_TO_SEE_PROJECT_APP_VERSION",
  /* * * * * * * * * *  * * * * * * * * */

  /* * * * * * * * * *  * * * * * * * * */
  /* * * * *  HY-DRY DEVICES  * * * * * */
  /* * * * * * * * * *  * * * * * * * * */
  SEARCH_ANY_HY_DRY_DEVICE_ICON = "SEARCH_ANY_HY_DRY_DEVICE_ICON",
  SEE_ALL_HY_DRY_DEVICES = "SEE_ALL_HY_DRY_DEVICES",                              // Tile 10
  EDIT_HY_DRY_DEVICES = "EDIT_HY_DRY_DEVICES",
  VIEW_POWER_INFORMATION = "VIEW_POWER_INFORMATION",
  VIEW_WEATHER_INFORMATION = "VIEW_WEATHER_INFORMATION",
  VIEW_INTENSITY = "VIEW_INTENSITY",

  CONTROL_COMBOX_VIA_IOT = "CONTROL_COMBOX_VIA_IOT",
  VIEW_POWER_ON_BUTTON = "VIEW_POWER_ON_BUTTON",
  VIEW_TEST_RELAYS_BUTTON = "VIEW_TEST_RELAYS_BUTTON",
  IOT_COMMANDS_ACCESS = "IOT_COMMANDS_ACCESS",
  SHOW_ALL_INFO = "SHOW_ALL_INFO",
  SHOW_OPEN_SETTINGS_ICON = "SHOW_OPEN_SETTINGS_ICON",
  SHOW_ADDITIONAL_DEVICE_INFO = "SHOW_ADDITIONAL_DEVICE_INFO",
  FORCE_LOAD_RUNS_VIA_IOT = "FORCE_LOAD_RUNS_VIA_IOT",

  SHOW_PROGRAM_QUALITY_RATING = "SHOW_PROGRAM_QUALITY_RATING",
  VIEW_HY_DRY_DEVICE_CONTROL = "VIEW_HY_DRY_DEVICE_CONTROL",
  VIEW_HY_DRY_DEVICE_DETAILS_OF_ALL_CLIENTS = "VIEW_HY_DRY_DEVICE_DETAILS_OF_ALL_CLIENTS",
  VIEW_RUNS = "VIEW_RUNS",
  VIEW_RUN_DETAILS = "VIEW_RUN_DETAILS",
  VIEW_RUN_STARTS_CAUSED_BY_MAX_RUN_DURATION = "VIEW_RUN_STARTS_CAUSED_BY_MAX_RUN_DURATION",

  MARK_END_DATE_MANUAL_CORRECTIONS = "MARK_END_DATE_MANUAL_CORRECTIONS",
  REMOVE_OUTLIER_SAMPLES = "REMOVE_OUTLIER_SAMPLES",

  CHANGE_PROGRAM_DURING_DRYING = "CHANGE_PROGRAM_DURING_DRYING",

  VIEW_SENSOR_DIAGNOSTICS = "VIEW_SENSOR_DIAGNOSTICS",

  VIEW_PROJECT_DETAILS_OF_ANOTHER_CLIENT = "VIEW_PROJECT_DETAILS_OF_ANOTHER_CLIENT",

  /* * * *   HY-DRY EVENT LOGS  * * * * */
  SEE_LID_AND_PAUSE_EVENT_LOGS = "SEE_LID_AND_PAUSE_EVENT_LOGS",
  SEE_SENSOR_EVENT_LOGS = "SEE_SENSOR_EVENT_LOGS",
  SEE_ALL_EVENT_LOGS = "SEE_ALL_EVENT_LOGS",
  TOGGLE_STEP_EVENT_LOGS = "TOGGLE_STEP_EVENT_LOGS",
  VIEW_CYCLE_INFO = "VIEW_CYCLE_INFO",
  VIEW_STEP_INFO = "VIEW_STEP_INFO",
  VIEW_LIMIT_LINES_FOR_RUNS = "VIEW_LIMIT_LINES_FOR_RUNS",

  /* * * * * *  DRYING HISTORY  * * * * */
  VIEW_DRYING_HISTORY_OF_ALL_CLIENTS = "VIEW_DRYING_HISTORY_OF_ALL_CLIENTS",
  /* * * * * * * * * *  * * * * * * * * */

  /* * * * * * * * * *  * * * * * * * * */
  /* * * * * *  ALL DEVICES   * * * * * */
  /* * * * * * * * * *  * * * * * * * * */
  EDIT_ALL_DEVICES = "EDIT_ALL_DEVICES",
  /* * * * * * * * * *  * * * * * * * * */

  /* * * * * * * * * *  * * * * * * * * */
  /* * * * * * *  MESSAGES *  * * * * * */
  /* * * * * * * * * *  * * * * * * * * */
  SEE_ALL_MESSAGES = "SEE_ALL_MESSAGES",
  /* * * * * * * * * *  * * * * * * * * */

  /* * * * * * * * * *  * * * * * * * * */
  /* * * * * * *  SETTINGS  * * * * * * */
  /* * * * * * * * * *  * * * * * * * * */
  VIEW_USER_SETTINGS = "VIEW_USER_SETTINGS",
  VIEW_COMPANY_SETTINGS = "VIEW_COMPANY_SETTINGS",
  VIEW_REPORT_SETTINGS = "VIEW_REPORT_SETTINGS",
  VIEW_HY_DRY_DEVICE_SETTINGS = "VIEW_HY_DRY_DEVICE_SETTINGS",
  VIEW_ALL_DEVICES_SETTINGS = "VIEW_ALL_DEVICES_SETTINGS",
  VIEW_MESSAGE_SETTINGS = "VIEW_MESSAGE_SETTINGS",
  VIEW_PROJECT_SETTINGS = "VIEW_PROJECT_SETTINGS",
  VIEW_SYSTEM_SETTINGS_SECTION = "VIEW_SYSTEM_SETTINGS_SECTION",
  VIEW_SYSTEM_SETTINGS = "VIEW_SYSTEM_SETTINGS",
  VIEW_TIME_TRACKING_SETTINGS = "VIEW_TIME_TRACKING_SETTINGS",
  VIEW_SCHEDULING_SETTINGS = "VIEW_SCHEDULING_SETTINGS",
  VIEW_IRES_SETTINGS = "VIEW_IRES_SETTINGS",
  VIEW_AI_PREDICTIONS = "VIEW_AI_PREDICTIONS",
  VIEW_USERS_CONFIGURATION_SETTINGS_ITEM = "VIEW_USERS_CONFIGURATION_SETTINGS_ITEM",
  VEHICLE_MANAGEMENT = "VEHICLE_MANAGEMENT",
  DEVICE_CHECK_MANAGEMENT = "DEVICE_CHECK_MANAGEMENT",
  ROLE_MANAGEMENT = "ROLE_MANAGEMENT",
  /**
   * The address-position features: the map pin beside every address, the picker it opens, and
   * the lookups they run. Not the standalone Karte screen, which is
   * {@link Capability.VIEW_MAP_PAGE}.
   */
  GEO_ENCODING = "GEO_ENCODING",
  /**
   * The standalone Karte screen in the navigation (`/main/maps`).
   *
   * Split out of {@link Capability.GEO_ENCODING} on 2026-09-07 because the two were one
   * capability and could therefore only ship together: the address-position features are ready
   * for clients while that screen is still under development. Keeping them joined meant releasing
   * the finished work would have put the unfinished screen in every client's sidebar.
   */
  VIEW_MAP_PAGE = "VIEW_MAP_PAGE",
  /**
   * The Mira screens in the navigation (`/main/mira`): the landing page and Datenqualität, which read
   * the figures the nightly Mira job publishes for the signed-in client.
   *
   * IRES's own access. Whether a client's users see Mira too is the client's Mira setting in
   * Systemkonfiguration (Nein / Nur IRES / Ja, #2610141), which `miraAccess()` combines with this.
   */
  VIEW_MIRA = "VIEW_MIRA",
  /**
   * Whether the Mira screens show the P15 / P85 percentiles beside the medians (the spread line on a
   * tile, the range behind the dot plot marks, the band on the Verlauf chart).
   *
   * In the same groups as {@link VIEW_MIRA}, so today exactly the same people see it. Whose figures
   * carry a spread is to be decided later (Taimoor, 2026-10-02): narrowing it is a permission change
   * only, no screen change.
   */
  VIEW_MIRA_PERCENTILES = "VIEW_MIRA_PERCENTILES",
  VIEW_EDIT_DEVICE_SETTINGS_ITEM = "VIEW_EDIT_DEVICE_SETTINGS_ITEM",
  EDIT_IRES_CATEGORIES_AND_TEMPLATES = "EDIT_IRES_CATEGORIES_AND_TEMPLATES",
  IMPORT_DEVICES = "IMPORT_DEVICES",
  MESSAGE_SELECTION = "MESSAGE_SELECTION",
  VIEW_MAILBOX = "VIEW_MAILBOX",
  VIEW_SYSTEM_CONFIGURATIONS = "VIEW_SYSTEM_CONFIGURATIONS",
  VIEW_DEVICE_MANAGER_SETTINGS = "VIEW_DEVICE_MANAGER_SETTINGS",
  VIEW_FINISHED_PROJECTS_SETTINGS = "VIEW_FINISHED_PROJECTS_SETTINGS",

  SYSTEM_CONFIGURATION_DISTRIBUTION = "SYSTEM_CONFIGURATION_DISTRIBUTION",
  CONFIGURE_ADMINSTRATOR_CLIENT = "CONFIGURE_ADMINSTRATOR_CLIENT",
  /* * * * * * * * * *  * * * * * * * * */

  /* * * * * * * * * *  * * * * * * * * */
  /* * * * *  USER MANAGEMENT * * * * * */
  /* * * * * * * * * *  * * * * * * * * */
  ADMIN_RIGHTS = "ADMIN_RIGHTS",
  CREATE_USER = "CREATE_USER",
  DELETE_USER = "DELETE_USER",
  EDIT_ADMIN = "EDIT_ADMIN",
  EDIT_OWN_ADMIN = "EDIT_OWN_ADMIN",
  EDIT_USER = "EDIT_USER",
  EDIT_VALIDATION = "EDIT_VALIDATION",
  BASIC_LICENCE = "BASIC_LICENCE",
  EDIT_SHARED_EMAIL_ADDRESS = "EDIT_SHARED_EMAIL_ADDRESS",
  SKIP_SETTING_SESSION_TOKEN = "SKIP_SETTING_SESSION_TOKEN",
  GRANT_ALL_LICENCES = "GRANT_ALL_LICENCES",
  DEFINE_SHARED_USER_ACCESS = "DEFINE_SHARED_USER_ACCESS",
  DEFINE_SHARED_USER_MASTER_CLIENT_ACCESS = "DEFINE_SHARED_USER_MASTER_CLIENT_ACCESS",
  SELECT_DEV_LANGUAGES = "SELECT_DEV_LANGUAGES",
  SKIP_USER_DATA_VALIDATION = "SKIP_VALIDATION_CHECKS",
  /* * * * * * * * * *  * * * * * * * * */

  /* * * * * * * * * *  * * * * * * * * */
  /* * * * * * ADMINISTRATION * * * * * */
  /* * * * * * * * * *  * * * * * * * * */
  VIEW_HY_DRY_DEVICES_OF_MEMBER_CLIENTS = "VIEW_HY_DRY_DEVICES_OF_MEMBER_CLIENTS",
  VIEW_CLIENT_SELECTOR = "VIEW_CLIENT_SELECTOR",
  VIEW_HY_DRY_DEVICE_DETAILS_OF_MEMBER_CLIENTS = "VIEW_HY_DRY_DEVICE_DETAILS_OF_MEMBER_CLIENTS",
  VIEW_DRYING_HISTORY_OF_MEMBER_CLIENTS = "VIEW_DRYING_HISTORY_OF_MEMBER_CLIENTS",

  MOVE_DEVICES_TO_CLIENT = "MOVE_DEVICES_TO_CLIENT",
  CONFIGURE_ADMINISTRATION_CAPABILITIES = "CONFIGURE_ADMINISTRATION_CAPABILITIES",
  CONFIGURE_ADMINISTRATION_SETTINGS = "CONFIGURE_ADMINISTRATION_SETTINGS",
  DEFINE_SYSTEM_CONFIGURATION = "DEFINE_SYSTEM_CONFIGURATION",
  CREATE_MEMBER_CLIENTS = "CREATE_MEMBER_CLIENTS",
  MANAGE_MEMBER_CLIENTS = "MANAGE_MEMBER_CLIENTS",

  VIEW_EXTERNAL_SYSTEMS = "VIEW_EXTERNAL_SYSTEMS",
  /* * * * * * * * * *  * * * * * * * * */

  /* * * * * * * * * *  * * * * * * * * */
  /* * * *  DATA VIEWER / LV  * * * * * */
  /* * * * * * * * * *  * * * * * * * * */
  /** Allows editing PDE, LV, and Beschreibung data in the data viewers */
  EDIT_DATA_VIEWER = "EDIT_DATA_VIEWER",
  /** Allows viewing and managing billing catalogs (Leistungslisten) in Settings */
  VIEW_BILLING_CATALOGS = "VIEW_BILLING_CATALOGS",
  /* * * * * * * * * *  * * * * * * * * */

  /* * * * * * * * * *  * * * * * * * * */
  /* * * * *  UNRELEASED / WIP  * * * * */
  /* * * * * * * * * *  * * * * * * * * */
  /**
   * Allows switching between light and dark appearance.
   *
   * Dark mode is finished in `development` but deliberately NOT released to clients yet, so this
   * gates it to IRES users. Note it does more than hide the toggle: without the capability the
   * theme is forced to light, because the stored preference otherwise falls back to the operating
   * system's `prefers-color-scheme` and a client on a dark-themed OS would land in dark mode with
   * no way out. See `docs/operations/unreleased-features.md`.
   */
  TOGGLE_DARK_MODE = "TOGGLE_DARK_MODE",
  /* * * * * * * * * *  * * * * * * * * */

  /* * * * * * * * * *  * * * * * * * * */
  /* * * * * *  ADMIN PORTAL  * * * * * */
  /* * * * * * * * * *  * * * * * * * * */
  /**
   * Allows rating the quality of AI drying predictions in the admin portal's review queue.
   * Granted by the "Drying Expert" role.
   *
   * **Must stay out of `IRES_CAPABILITIES`, `ADMIN_CAPABILITIES` and `GENERAL_CAPABILITIES`.**
   * The admin-portal client is `clientType: "IRES"`, so `hasCapability()` would short-circuit and
   * grant this to every one of its users without ever consulting their role. Keeping it out of all
   * three groups is what forces resolution through role settings, and therefore what makes a
   * reviewer-only role possible at all.
   */
  RATE_DRYINGS = "RATE_DRYINGS",
  /**
   * Allows working with production data in the admin portal: the JSON test reports the production
   * rig uploads for each device, and the device creation flows as they migrate out of the IRES
   * Admin Android app.
   *
   * Named for the job rather than for one screen, so it survives the reports view being extended or
   * renamed, exactly as {@link RATE_DRYINGS} is.
   *
   * **Must stay out of `IRES_CAPABILITIES`, `ADMIN_CAPABILITIES` and `GENERAL_CAPABILITIES`**, for
   * the same reason as {@link RATE_DRYINGS}: the admin-portal client is `clientType: "IRES"`, so
   * `hasCapability()` would grant it to every one of its users without consulting their role, and a
   * production-only role would be impossible.
   */
  MANAGE_PRODUCTION = "MANAGE_PRODUCTION",
  /**
   * Allows administering clients in the admin portal: the clients list, and the client detail,
   * properties and creation screens as they migrate out of the IRES Admin Android app.
   *
   * Named for the job rather than for one screen, exactly as {@link MANAGE_PRODUCTION} is.
   *
   * **Must stay out of `IRES_CAPABILITIES`, `ADMIN_CAPABILITIES` and `GENERAL_CAPABILITIES`**, for
   * the same reason as {@link RATE_DRYINGS}: the admin-portal client is `clientType: "IRES"`, so
   * `hasCapability()` would grant it to every one of its users without consulting their role.
   */
  MANAGE_CLIENTS = "MANAGE_CLIENTS"
  /* * * * * * * * * *  * * * * * * * * */
}